import Instance from "../axios/Instance";
// export const getDashboardData = () => {
//     return Instance.get('/indicators/dashboard').then(response =>response).catch(error => error);
// }
// export const getDashboardDataTest = (cycle,key,subject) => {
//     return Instance.get(`/indicators?cycle=${cycle}&key=${key}&subject=${subject}`).then(response =>response).catch(error => error);
// }

// export const getCommercialStructureMenu = () => {
//     return Instance.get(`/application/commercialStructure/menu`).then(response =>response).catch(error => error);
// }

// export const getDashboardResume=()=>{
//     return Instance.get('/indicators/resume').then(response =>response).catch(error => error);
// }

export const getIndicatorsSubject = (subjectId) => {
    return Instance.get(`/indicators/subject/${subjectId}`).then(response => response);
}
export const getDataIndicator = (indicatorId, cycle, stId) => {
    return Instance.get(`/indicators/data/${indicatorId}?cycle=${cycle}&stId=${stId}`).then(response => response);
}
export const getChildsIndicators = (indicatorId, cycle, stId) => {
    return Instance.get(`/indicators/data/childs/${indicatorId}?cycle=${cycle}&stId=${stId}`).then(response => response);
}
